'use client';

import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/navigation';
import dynamic from 'next/dynamic';
import { useSearchContentByLocation } from 'hooks/useSearchContentByLocation';
import { useGetPathWithLocation } from 'hooks/useGetPathWithLocation';
import locationStore from 'stores/LocationStore';
import { searchEventStore } from 'stores/SearchContentBaseStore';
import { PageType } from 'constants/enums/search';
import { ANYWHERE_LOCATION, NEAR_TO_YOU_LABEL } from 'constants/index';
import { getGeolocationModalData } from '../utils/getGeolocationModalData';
import * as styles from './GeolocationModal.css';
import { urlPathname } from 'constants/search';
import { Location, LocationResponse } from 'location.d';

const Button = dynamic(() => import('@sympla/sympla-components/Button'), {
  ssr: false
});

const IconArrowLocation = dynamic<IconProps>(
  () =>
    import('@sympla/sympla-components/ActionIcons').then(
      (mod) => mod.IconLocalizationFill
    ),
  {
    ssr: false
  }
);

const CloseButtonModal = dynamic(
  () => import('components/Shared/CloseButtonModal/CloseButtonModal'),
  {
    ssr: false
  }
);

function GeolocationModal() {
  const router = useRouter();
  const searchContent = useSearchContentByLocation();
  const getPathWithLocation = useGetPathWithLocation();

  const data: LocationResponse = getGeolocationModalData(
    (location: Location) => {
      const changeCity: boolean =
        locationStore?.selectedLocation?.slug !== location.slug &&
        !!locationStore?.selectedLocation?.slug;

      locationStore.setSelectedLocation(location);

      const noCity: boolean = [ANYWHERE_LOCATION, NEAR_TO_YOU_LABEL].includes(
        location?.city
      );

      const query: string = window?.location?.search;
      const url: string = getPathWithLocation({ location, changeCity });

      if (
        (searchEventStore.typePage === PageType.COLLECTION && noCity) ||
        (url?.includes(urlPathname.partners) && noCity)
      ) {
        window.location.href = `${url}${query}`;
        return;
      }

      // TODO: searchContent should change when home and other pages are finished
      searchContent(query);

      if (url) router.push(`${url}${query}`);
    }
  );

  return (
    <div className={styles.container}>
      <CloseButtonModal
        ariaLabel="Fechar modal de localização"
        iconSize={24}
        top={8}
        right={8}
        onClick={() => locationStore.setIsGeolocationModalVisible(false)}
      />
      <IconArrowLocation width={24} height={24} />
      <p className={styles.title}>{data.title}</p>
      <p className={styles.text}>{data.text}</p>
      <div className={styles.buttonsWrapper}>
        <Button
          size="small"
          onClick={() => {
            locationStore.setIsGeolocationModalVisible(false);
            data.onAccept();
          }}
        >
          {data.buttonLabel}
        </Button>
        <Button
          size="small"
          variant="text"
          onClick={() => {
            locationStore.setIsGeolocationModalVisible(false);
            data.onCancel();
          }}
        >
          Agora não
        </Button>
      </div>
    </div>
  );
}

export default observer(GeolocationModal);
